export default __webpack_public_path__ + "80341746804c76cc4ad917b2a54b3bc2.jpg";